import SORT_ORDER from 'src/enums/sortOrder';
import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import UserContext from 'src/services/UserContext';
import { Filters } from '../../ProductAlertsProvider';
import { ColumnSorting } from '../ProductSegmentTable/ProductSegmentTable.config';
import ProductSegment from '../../types/ProductSegment';
import ProductSegmentList from '../../types/ProductSegmentList';
import { getProductSegments } from '../../api/productAlerts.api';

export type ProductSegmentListState = FetchState<ProductSegment[]> & {
  total: number;
  page: number;
  offset: number;
  size: number;
};

type PropsUseProductSegmentListFetch = {
  filters: Filters;
  sorting: ColumnSorting;
  page: number;
  pageSize: number;
  forcedReload: object | null;
};

const initialState: ProductSegmentListState = {
  loading: false,
  error: false,
  data: null,
  total: 0,
  page: 1,
  offset: 1,
  size: 0,
};

const useProductSegmentListFetch = ({
  filters,
  sorting,
  page,
  pageSize,
  forcedReload,
}: PropsUseProductSegmentListFetch): [ProductSegmentListState] => {
  const params: ProductSegmentList.Request = {
    sortingOrder: SORT_ORDER[sorting.order],
    sortingColumn: sorting.field,
    size: pageSize,
    offset: page > 1 ? (page - 1) * pageSize + 1 : 1,
    segmentname: filters.segmentName,
    createdby: filters.createdBy,
    favourite: filters.favourite,
    shared: filters.shared,
    showall: filters.showAll,
    createdstart: filters.createdStart,
    createdend: filters.createdEnd,
    timeZoneName: UserContext.getTimeZoneName(),
  };

  //TODO fix dependencies
  const [{ loading, data, error }] = useFetchReducer(
    () => getProductSegments(params),
    [sorting, page, pageSize, filters, forcedReload]
  );
  const state: ProductSegmentListState = { ...initialState, loading, error };

  if (data === null) {
    return [state];
  }

  //TODO do we need sortingorder, sortingcolumn, size, offset from response?
  const { productSegmentList, totalRecords /* sortingorder, sortingcolumn, size, offset */ } = data;

  return [
    {
      ...state,
      data: productSegmentList,
      total: Number(totalRecords),
    },
  ];
};

export default useProductSegmentListFetch;
